
// Centralized z-index constants - Compact range with gesture support
export const LAYERS = {
  // Base content (0-20)
  BACKGROUND: 0,
  HERO_IMAGE: 5,
  PRAYER_CARD: 10,
  PRAYER_ACTION_ICONS: 15,
  PRAYER_METADATA: 20,
  
  // Page structure (50-60) - Below dialogs
  HEADER_FOOTER: 50,
  NAVIGATION_ARROWS: 55,
  
  // Dialog backdrop layer (65)
  DIALOG_BACKDROP: 65,
  
  // Primary dialogs (70-90)
  DIALOG_CONTENT: 75,
  DIALOG_HEADER: 80,
  DIALOG_GESTURES: 85, // Gesture overlays within dialog band
  DIALOG_CTA: 87,
  DIALOG_AUTHOR_OVERLAY: 90,
  
  // Secondary dialogs (95-105) - Choice, Generated Prayer, etc.
  PRAYER_CHOICE: 95,
  CHOICE_GESTURES: 98, // Gesture overlays for choice dialog
  AI_ASSISTANT: 100,
  GENERATED_PRAYER: 102,
  GENERATED_PRAYER_GESTURES: 105, // Gesture overlays for generated prayer
  
  // System overlays (110-120)
  FLOAT_ACTION_BAR: 110,
  DROPDOWN: 112,
  TOAST: 115,
  AUDIO: 120,

  // Legacy mappings for backward compatibility
  PRAYER_DIALOGS: 95, // Maps to PRAYER_CHOICE
  FLOAT_BTN: 110, // Maps to FLOAT_ACTION_BAR
  ACTION_CNT: 110, // Maps to FLOAT_ACTION_BAR
  DIALOG_HDR: 80, // Maps to DIALOG_HEADER
  CONTENT_OVR: 75, // Maps to DIALOG_CONTENT
  SECONDARY_DIALOGS: 95, // Maps to PRAYER_CHOICE
  GESTURES: 85, // Maps to DIALOG_GESTURES
  GESTURE_HINTS: 85, // Maps to DIALOG_GESTURES
  PREVIEW_30: 75, // Maps to DIALOG_CONTENT
  DIALOG_HEADER_5: 80, // Maps to DIALOG_HEADER
  NAVIGATION_GESTURES: 55, // For page navigation gestures
};

// Legacy support - Prayer Detail Expanded Mode Layers - FIXED: Now aligns with page header/footer
export const PRAYER_DETAIL_EXPANDED_LAYERS = {
  DIALOG_FRAME: LAYERS.HEADER_FOOTER, // Changed from LAYERS.DIALOG_CONTENT to LAYERS.HEADER_FOOTER (z-75)
  ACTION_BAR: LAYERS.FLOAT_ACTION_BAR,
};

// Dialog-specific slots within the dialog content "band"
export const DIALOG_LAYERS = {
  BACKDROP: LAYERS.DIALOG_BACKDROP,
  BOTTOM_SHEET: LAYERS.DIALOG_CONTENT,
  CONTENT: LAYERS.DIALOG_CONTENT,
  HEADER: LAYERS.DIALOG_HEADER_5,
  FLOAT_ACTIONS: LAYERS.DIALOG_AUTHOR_OVERLAY,

  // Secondary stack (e.g. nested dialogs)
  BACKDROP_L2: LAYERS.SECONDARY_DIALOGS - 5,
  CONTENT_L2: LAYERS.SECONDARY_DIALOGS,
  HEADER_L2: LAYERS.SECONDARY_DIALOGS + 5,
  FLOAT_ACTIONS_L2: LAYERS.SECONDARY_DIALOGS + 10
};
